import React from 'react';
import { Link } from 'react-router-dom';
import {FaBuilding } from 'react-icons/fa';
import './FederalStateDashboard.css';

function FederalStateDashboard() {
    return (
        <div className="dashboard-container">
            <h2 className="dashboard-title">Bildungsdirektion-Dashboard</h2>
            <div className="dashboard-links">
                <Link to="/mdb/federalState/overview" className="dashboard-link">
                    <FaBuilding className="icon" />
                    Übersicht der Mitverwendungen
                </Link>
            </div>
        </div>
    );
}

export default FederalStateDashboard;

